import React from 'react';
import './TransparentCover.less';
import classNames from 'classnames';

export interface TransparentCoverProps {
    children: React.ReactElement[];

    disabled: boolean;
}

export const TransparentCover = (props: TransparentCoverProps) => {
    const className = classNames('transparentCover', {
        disabled: props.disabled,
    });

    return <div className={className}>{props.children}</div>;
};
